import { AdminNavigationSetup } from "@app/components/layouts/AdminNavigationSetup";
import { useSetContentWidth } from "@app/components/sparkle/AppLayoutContext";
import { useWorkspace } from "@app/lib/auth/AuthContext";
import { usePathParams } from "@app/lib/platform";
import { useSpaceInfo } from "@app/lib/swr/spaces";
import { Chip, InfoCircle, Page, Spinner } from "@dust-tt/sparkle";
import type React from "react";

interface SpaceLayoutProps {
  children: React.ReactNode;
}

export function SpaceLayout({ children }: SpaceLayoutProps) {
  const params = usePathParams();
  const spaceId = params.spaceId;

  const owner = useWorkspace();

  const {
    spaceInfo: space,
    canReadInSpace,
    isSpaceInfoLoading,
  } = useSpaceInfo({
    workspaceId: owner.sId,
    spaceId: spaceId ?? null,
  });

  useSetContentWidth("wide");

  return (
    <>
      <AdminNavigationSetup />
      {isSpaceInfoLoading || !space ? (
        <div className="flex h-full items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div className="flex w-full flex-col mb-4">
          <Page.Vertical gap="lg" align="stretch">
            {!canReadInSpace && space.kind !== "system" && (
              <div>
                <Chip
                  color="warning"
                  label="You are not a member of this space."
                  size="sm"
                  icon={InfoCircle}
                />
              </div>
            )}
            {children}
          </Page.Vertical>
        </div>
      )}
    </>
  );
}
